import { render, staticRenderFns } from "./create-questions-catalogue.vue?vue&type=template&id=3aa1cffb&scoped=true&"
import script from "./create-questions-catalogue.vue?vue&type=script&lang=ts&"
export * from "./create-questions-catalogue.vue?vue&type=script&lang=ts&"
import style0 from "./create-questions-catalogue.vue?vue&type=style&index=0&id=3aa1cffb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa1cffb",
  null
  
)

export default component.exports